import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { EmailManagerStore } from '../../services/stores/email-manager.store';
import { EmailModelDTO } from '../../models/email-manager.model.dto';
import { UiStateStore } from '../../services/stores/ui-state.store';
import { OrganizationStore } from '../../services/stores/organization.store';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { MaterialModule } from '../../modules/catch-core/third-party/material/material.module';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
  standalone: false,
})
export class FeedbackComponent implements OnInit {
  feedbackForm!: FormGroup;
  private feedbackEmail: any;
  private organisation: any;
  private organisationName: any;

  constructor(
    private fb: FormBuilder,
    private emailManagerStore: EmailManagerStore,
    public dialogRef: MatDialogRef<FeedbackComponent>,
    private uiStateStore: UiStateStore,
    private userService: UserService,
    private organizationStore: OrganizationStore,
  ) {}

  ngOnInit() {
    this.emailManagerStore.$firstEmailManager.subscribe((em) => {
      if (em) {
        this.feedbackEmail = em.feedbackEmail;
      }
    });

    this.organisation = this.organizationStore.$firstOrganization.subscribe((org) => {
      if (org) {
        this.organisationName = org.name;
      }
    });

    this.createForm();
  }

  createForm() {
    this.feedbackForm = this.fb.group({
      createdDate: '',
      modifiedDate: '',
      description: '',
      createdBy: '',
      modifiedBy: '',
      // emailAddress: ['', Validators.email],
      // firstName: ['', Validators.required],
      // lastName: ['', Validators.required],
      content: ['', Validators.required],
    });
  }

  sendEmail() {
    this.uiStateStore.startBackendAction('Sending feedback...');
    const emailEntity = this.prepareSaveComment();
    if (!emailEntity) {
      return;
    }
    this.emailManagerStore.$sendEmail(emailEntity).subscribe(
      (success) => {
        if (success) {
          this.uiStateStore.endBackendAction('');
          this.dialogRef.close(true);
        }
      },
      (error) => {
        this.uiStateStore.endBackendAction('');
      },
    );
  }

  prepareSaveComment() {
    if (!this.userService.user) {
      return;
    }
    const formModel = this.feedbackForm.value;
    let userInfomation = '';
    userInfomation += 'User information: \n';
    userInfomation += 'First Name: ' + this.userService.user.firstName + '\n';
    userInfomation += 'Last Name: ' + this.userService.user.lastName + '\n';
    userInfomation += 'Email: ' + this.userService.user.emailAddress + '\n';
    userInfomation += 'Organisation: ' + this.organisationName;

    const email = new EmailModelDTO({
      toEmail: this.feedbackEmail,
      subject: 'User Feedback',
      fromName: 'CatchHub Feedback Form',
      content: formModel.content + '\n\n' + userInfomation,
    });
    return email;
  }
}
